export enum CalculationMode {
  Distance = 'distance',
  Duration = 'duration',
  Airport = 'airport',
  Address = 'address',
  TIM = 'tim',
}
